<template>
  <div
    class="chat_box white"
    :class="{ 'chat_box--scroll': scroll, ['d-' + display]: display }"
    :style="{ borderRadius: borderRadius }"
    @scroll="handleScroll"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ChatBox',
  props: {
    borderRadius: { type: String, default: '0px' },
    scroll: Boolean,
    display: { type: String, default: 'grid' },
  },
  methods: {
    handleScroll(e) {
      if (this.scroll) {
        this.$emit('scroll', e)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.chat_box {
  box-shadow: 0px 9px 10px rgba(239, 239, 239, 0.25);
  position: relative;
  &--scroll {
    overflow-y: auto;
  }
}
</style>
